// default app vars

let g_dev = false;
let g_windowHeight = $(window).height();
let g_windowWidth = $(window).width();
let g_scroll = $(window).scrollTop();

// custom vars
let scrollMargin = 20;
let scrollTreshold = 25;

$(window).on('scroll', function () {
    g_scroll = $(window).scrollTop();
});

// On windows.resize
$(window).on('resize', function () {
    // Set window height/width on resize
    g_windowHeight = $(window).height();
    g_windowWidth = $(window).width();
});

$("#more-cases-btn").on('click', function (e) {
    e.preventDefault();
    $("#more-cases-btn").addClass('d-none');
    $("#more-cases").removeClass('d-none');
});

var resize;

$('.slider-cases img').on('lazyloaded',function(){
    clearTimeout(resize);
    resize = window.setTimeout(function(){
        equalHeight();
    }, 500);
});


/*
var typedText = document.querySelector('.typed-text');
var typedTextLineOne = document.querySelector('.typed-text-line-1').innerHTML;
var typedTextLineTwo = document.querySelector('.typed-text-line-2').innerHTML;

var typewriter = new Typewriter(typedText, {
    loop: true,
    delay: 75,
});

typewriter
    .typeString(typedTextLineOne)
    .pauseFor(2000)
    .deleteAll()
    .typeString(typedTextLineTwo)
    .pauseFor(2000)
    .start();
*/
